import React from 'react';
import { motion } from 'framer-motion';
export function Transformation() {
  return <section className="py-24 bg-white px-4 text-center" data-id="element-216">
      <div className="max-w-4xl mx-auto" data-id="element-217">
        <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-12" data-id="element-218">
          Lo que cambia en 7 días no es “tu acento”…
        </h2>

        <div className="grid gap-6 text-left max-w-2xl mx-auto" data-id="element-219">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex items-center p-4 bg-green-50 rounded-xl border border-green-100" data-id="element-220">
            <span className="text-2xl mr-4" data-id="element-221">😌</span>
            <p className="text-lg font-medium text-gray-800" data-id="element-222">
              Dejas de sentir que cada conversación es un examen
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex items-center p-4 bg-green-50 rounded-xl border border-green-100" data-id="element-223">
            <span className="text-2xl mr-4" data-id="element-224">⚡️</span>
            <p className="text-lg font-medium text-gray-800" data-id="element-225">
              Empiezas a tener respuestas automáticas
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="flex items-center p-4 bg-green-50 rounded-xl border border-green-100" data-id="element-226">
            <span className="text-2xl mr-4" data-id="element-227">🗣️</span>
            <p className="text-lg font-medium text-gray-800" data-id="element-228">
              Te atreves a pedir que repitan (sin pena)
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex items-center p-4 bg-green-50 rounded-xl border border-green-100" data-id="element-229">
            <span className="text-2xl mr-4" data-id="element-230">📉</span>
            <p className="text-lg font-medium text-gray-800" data-id="element-231">
              La ansiedad baja porque ya no estás improvisando
            </p>
          </motion.div>
        </div>

        <div className="mt-16 p-8 bg-gray-900 text-white rounded-3xl inline-block shadow-2xl transform rotate-1" data-id="element-232">
          <p className="text-2xl md:text-3xl font-bold" data-id="element-233">
            "Tu acento puede quedarse. <br data-id="element-234" />
            <span className="text-yellow-400" data-id="element-235">Tu silencio no.</span>"
          </p>
        </div>
      </div>
    </section>;
}